import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, errMsg } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { AuthLayout, authInput, authBtn, Link } from "../components/AuthLayout";

export default function Login() {
  const { signIn } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setErr("");
    try {
      const { data } = await api.post("/auth/login", { email, password });
      signIn(data);
      nav("/");
    } catch (e2) { setErr(errMsg(e2)); }
    setBusy(false);
  };
  return (
    <AuthLayout title="Log in to your terminal" noticeTestid="login-notice-text" subtitle="Welcome back. Markets are waiting."
      footer={<>New here? <Link to="/register" className="text-primary font-medium" data-testid="goto-register">Create a free account</Link></>}>
      <form onSubmit={submit} className="space-y-3" data-testid="login-form">
        <input data-testid="login-email-input" type="text" autoComplete="username" required placeholder="Email or Login ID" value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} />
        <input data-testid="login-password-input" type="password" required placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} className={authInput} />
        {err && <div className="text-down text-[12px]" data-testid="login-error">{err}</div>}
        <button data-testid="login-submit-button" disabled={busy} className={authBtn}>{busy ? "Logging in…" : "Log in"}</button>
        <Link to="/forgot-password" className="block text-[12px] text-muted-foreground hover:text-foreground" data-testid="goto-forgot">Forgot password?</Link>
      </form>
    </AuthLayout>
  );
}
